import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useGetVehicleQuery } from '../../../api/queries/getVehicle';
import { useListDealersQuery } from '../../../api/queries/listDealers';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import FinderVehicleForm from './FinderVehicleForm';

const FinderVehicleDetailsPage = () => {
    const { id } = useParams<{ id: string }>();

    const { data, loading, refetch } = useGetVehicleQuery({
        fetchPolicy: 'network-only',
        variables: { id },
    });

    const { data: dealerData, loading: dealerLoading } = useListDealersQuery({
        fetchPolicy: 'cache-and-network',
    });

    const finderVehicle = useMemo(() => {
        if (data?.vehicle?.__typename !== 'FinderVehicle') {
            return null;
        }

        return data.vehicle;
    }, [data]);

    const isPartnerNumberSetup = useMemo(() => {
        if (dealerLoading || !finderVehicle || !dealerData) {
            return false;
        }

        return dealerData.page.items.some(
            ({ integrationDetails }) =>
                integrationDetails.partnerNumber === finderVehicle.listing.seller.porschePartnerNumber
        );
    }, [dealerData, dealerLoading, finderVehicle]);

    if ((!finderVehicle && loading) || dealerLoading) {
        return <LoadingElement />;
    }

    if (!finderVehicle) {
        return <NotFoundResult />;
    }

    return (
        <FinderVehicleForm
            finderVehicle={finderVehicle}
            isPartnerNumberSetup={isPartnerNumberSetup}
            refetch={refetch}
        />
    );
};

export default FinderVehicleDetailsPage;
